import { createSlice } from '@reduxjs/toolkit';

import { industries } from '../../../shared/utils';

export const industryOptions = industries.map((industry, index) => ({
  value: industry,
  text: industry,
  key: index
}));

const useCaseOptions = [
  'A form to collect client or customer requests.',
  'A registration form for events (e.g. webinars, conferences)',
  'Registration form for programs or services (e.g. fellowships, government services, NGOs)',
  'Registration or sign-up form for classes or courses',
  'A product or service order form.',
  'A job application or employee onboarding form.',
  'A survey or feedback form.',
  'An internal workflow or approval form.',
  'An inventory or asset tracking form.',
  'A research or field data collection form.',
  'Academic tasks forms like quizzes or assignments (Educators)',
  'Forms for managing student data or records (Admins/Registrars)',
  'A report or compliance tracking form.',
  'Just exploring, not sure yet.'
].map((value) => ({
  text: value,
  value
}));

export const defaultState = {
  industryOptions,
  useCaseOptions,
  feedback: {
    isLoading: false,
    success: false,
    message: ''
  },
  model: {
    collect_email: false,
    receive_mail: false,
    phone_number: '',
    formplus_use: '',
    token_key: '',
    industry: '',
    email: '',
    name: ''
  },
  error: {
    phone_number: '',
    formplus_use: '',
    email: '',
    name: ''
  }
};

const detailsSlice = createSlice({
  initialState: defaultState,
  name: 'details',
  reducers: {
    updateFieldOptions: (state, { payload }) => {
      const { fieldOptionsKey, newOption } = payload;

      const currentFieldOptions = state[fieldOptionsKey];
      
      state[fieldOptionsKey] = [
        ...currentFieldOptions,
        newOption
      ];
    },
    setIndustryOptions: (state, { payload }) => {
      state.industryOptions = payload;
    },
    updateFeedback: (state, { payload }) => {
      if (!payload) {
        state.feedback = defaultState.feedback;
      } else {
        state.feedback = {
          ...state.feedback,
          ...payload
        };
      }
    },
    updateModel: (state, { payload }) => {
      // Reset error on field change.
      for (const field of Object.entries(payload)) {
        state.error[field] = ''
      }

      state.model = {
        ...state.model,
        ...payload
      };
    },
    updateError: (state, { payload }) => {
      state.error = {
        ...state.error,
        ...payload
      };
    }
  }
});

export const {
  updateFieldOptions,
  setIndustryOptions,
  updateFeedback,
  updateModel,
  updateError
} = detailsSlice.actions;

export default detailsSlice.reducer;